import {
  IParamMapper,
  ISimpleCRUDServiceFactory
} from "../../../service/SimpleCRUDServiceFactory";
import { RequestArgs } from "../../../service/HttpService";

export default class CreateListResourceInteractor<T> {
  private serviceFactory: ISimpleCRUDServiceFactory<T>;

  constructor({ simpleCRUDServiceFactory }: any) {
    this.serviceFactory = simpleCRUDServiceFactory;
  }

  async execute(
    basePath: string,
    model: T[],
    args?: RequestArgs,
    ParamMapper?: IParamMapper<T>
  ) {
    const result = await this.serviceFactory
      .create({
        basePath,
        ParamMapper
      })
      .createListResource(model, args);
    return result;
  }
}
